
import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import './jobstatus.scss';
import JobListItem from './jobList-item/JobListItem';
 
import Paginator from './jobList-item/paginator'
import LoadingOverlay from 'react-loading-overlay';




function JobStatus(props) { 
   
const {jobdetails } = props

const reload = () => {
    window.location.reload();
}
   
   return (
        <React.Fragment>
            <div className="jobstatus-table-container">

<LoadingOverlay

active={!(props?.state?.isLoading === false)}
spinner
text='Loading'
>
                <Row>
                    <Col md='12'>
                        <div className='job-data'>
                            <div className='sm-header'> JobId</div> 
                            <div className='lg-header'>Job Name</div>
                            <div className='lg-header'>Rule Name</div>
                            <div className='lg-header'>Job Status</div>
                            <div className='lg-header'>StartTime</div>
                            <div className='lg-header'>EndTime</div>
                            
                        </div>
                    </Col>
                    
                </Row>
                <div className="jobstatus-detail-container">
                    <Row>
                    {jobdetails && jobdetails.length > 0 ?
                           jobdetails.map(job =>
                        <JobListItem          
                         job={job}
                          
                         />)
                        
                        :""
                    }                                             
                        </Row>    
                </div>
                
            
            <Row>
              <Paginator />
              <button className='btn btn-primary' onClick={reload}>Refresh</button>
                    
                </Row>
                </LoadingOverlay>
                </div >
        </React.Fragment >
    )
}
export default JobStatus;